import { Injectable } from '@angular/core';
import mixpanel from 'mixpanel-browser'
import {environment} from "../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class MixpanelService {

  constructor() {
    this.init();
  }

  init(): void {
    mixpanel.init(environment.mixpanelKey,
      {
        track_pageview: true,
        persistence: 'cookie',
        cross_subdomain_cookie: true,
        record_sessions_percent: 100,
        api_host: 'https://api-eu.mixpanel.com'
      });
  }

  identify(userId: string) {
    mixpanel.identify(userId);
  }

  addProfileProperties(name: string, email: string) {
    mixpanel.people.set({
      name: name,
      email: email,
    });
  }

  startRecording() {
    mixpanel.start_session_recording();
  }

  track(actionName: string, properties: any = {}): void {
    mixpanel.track(actionName, properties);
  }
}
